import get from 'lodash/get'

import { useGetListingReviewsQuery } from 'hooks/useQueries'
import ReviewScore from 'components/reviews/ReviewScore'
import ReviewList from 'components/reviews/ReviewList'
import Button from 'components/display/Button'
import { Section, SectionTitle, SubSection } from './shared'
import { ListingProps } from '../types'

interface ListingReviewProps {
  listing: ListingProps
  openReviewModal: (arg: boolean) => any
}

const ListingReview = ({ listing, openReviewModal }: ListingReviewProps) => {
  const { loading, data } = useGetListingReviewsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      listingId: listing.id,
    },
  })
  const reviewsConnection = get(data, 'listing.reviews')
  const hasNextPage = get(data, 'listing.reviews.pageInfo.hasNextPage')

  return (
    <Section
      // @ts-ignore -- not typed yet
      borderTop
    >
      <SectionTitle>Reviews ({listing.review_count})</SectionTitle>

      <SubSection
        // @ts-ignore -- not typed yet
        lessMargin
      >
        {listing.review_score > 0 && (
          <ReviewScore score={listing.review_score} size="large" />
        )}
      </SubSection>

      <ReviewList loading={loading} reviewsConnection={reviewsConnection} />

      {hasNextPage && (
        <Button
          onClick={() => openReviewModal(true)}
          ghost
          uppercase={false}
          style={{ margin: '30px auto 0 auto' }}
        >
          See all reviews
        </Button>
      )}
    </Section>
  )
}

export default ListingReview
